import React from 'react';
import Svg, { Path } from 'react-native-svg';

export const NovaNotesIcon = () => (
  <Svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <Path
      d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V32C36 34.2091 34.2091 36 32 36H4C1.79086 36 0 34.2091 0 32V4Z"
      fill="#00A63E"
      fillOpacity="0.1"
    />
    <Path
      d="M20.5013 9.66797H15.5013C15.0411 9.66797 14.668 10.0411 14.668 10.5013V12.168C14.668 12.6282 15.0411 13.0013 15.5013 13.0013H20.5013C20.9615 13.0013 21.3346 12.6282 21.3346 12.168V10.5013C21.3346 10.0411 20.9615 9.66797 20.5013 9.66797Z"
      stroke="#00A63E"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M21.332 11.332H22.9987C23.4407 11.332 23.8646 11.5076 24.1772 11.8202C24.4898 12.1327 24.6654 12.5567 24.6654 12.9987V24.6654C24.6654 25.1074 24.4898 25.5313 24.1772 25.8439C23.8646 26.1564 23.4407 26.332 22.9987 26.332H12.9987C12.5567 26.332 12.1327 26.1564 11.8202 25.8439C11.5076 25.5313 11.332 25.1074 11.332 24.6654V12.9987C11.332 12.5567 11.5076 12.1327 11.8202 11.8202C12.1327 11.5076 12.5567 11.332 12.9987 11.332H14.6654"
      stroke="#00A63E"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M18 17.168H21.3333"
      stroke="#00A63E"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M18 21.332H21.3333"
      stroke="#00A63E"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M14.668 17.168H14.6763"
      stroke="#00A63E"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M14.668 21.332H14.6763"
      stroke="#00A63E"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
